import { ReactNode, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { BT, Container, ImageContainer, ItemInfo, ItemName, ListContainer, ListItem, TagPill, TopTitle } from './GuardianHoliday.styled';
import { Buttons, ChildContainer, ChildInfo, GuardianWrapper, HeadLine, ItemButtons, LessonItem, LessonList, PillContainer, PopClose, PopCol, PopContainer, PopItem, PopRow, PopRowButtons, PopSubTitle, PopTitle, ProfilContent, StatusCorner, TnfoText } from '../Guardian.styled';
import DatePicker, { registerLocale } from 'react-datepicker';
import { da } from 'date-fns/locale/da';
import { enGB as en } from 'date-fns/locale/en-GB';
import { useDetectClickOutside } from 'react-detect-click-outside';
import Clock_Icon from "@assets/svg/match/late.svg";
import Calendar_Icon from "@assets/svg/new_calendar.svg";
import StudentThumbnail from '@components/StudentThumbnail';
import Modal from '@components/Buttons/Modal';
import Close_Icon from "@assets/svg/match/missing.svg";
import Check_Icon from '@assets/svg/match/attending.svg';
import Denied_Icon from '@assets/svg/match/missing.svg';
import Pending_Icon from '@assets/svg/match/late.svg';
import moment from 'moment';
import EmptyBox from '@components/SchoolLeader/EmptyBox';
import RainbowLoader from '@components/Loaders/RainbowLoader';
import CardInfo from '@components/GridCards/CardInfo';
import toTitleCase from '@utils/textTools';
import db from '@utils/db';
import { useStore } from "@store/appStore";

registerLocale('da', da);
registerLocale('en-GB', en);


interface IProps {
  updateStudents?: () => void,
  holidayRequests?: any,
  students?: any,
  loading?:boolean,
  handleEditHoliday?: (requestinfo) => void
}

export const GuardianHoliday = (props: IProps) => {
  const [modalHoliday, setModalHoliday] = useState(false)
  const modalHolidayRef = useRef(null);
  const i18n = useI18n();
  const [showAll, setShowAll] = useState(false)
  const [selectedholidayrequest, setSelectedHolidayRequest] = useState(null)
  const { client } = useStore()
  

  const filterActivities = () => {
    if (showAll) return props.holidayRequests?.sort((a, b) => moment(b.startdatetime).diff(moment(a.startdatetime)));
    else {
      let now = moment()
      return props.holidayRequests?.sort((a, b) => moment(b.startdatetime).diff(moment(a.startdatetime)))?.filter(a => moment(a.enddatetime).isSameOrAfter(now, 'date'))
    }
  }

  const getStudent = (id) => {
    let student = props.students?.find(s => s.student_id === id)
    if (student) return student
    else {
      return {}
    }
  }

  const getStatus = (approved, waiting) => {
    if (approved) return <><Check_Icon />{i18n.t('approved')} </>
    else if (!approved && waiting === false) return <><Denied_Icon />{i18n.t('denied')} </>
    else return <><Pending_Icon />{i18n.t('waiting')} </>
  }

  const getTime = (startdatetime, enddatetime) => {
      let start = moment(startdatetime)
      let end = moment(enddatetime)
      if (start.hour() === 0 && start.minute() === 0 && end.hour() === 0 && end.minute() === 0)
        return <span>{moment(startdatetime).format('DD MMM YYYY')} - {moment(enddatetime).format('DD MMM YYYY')}</span>
      else return <span>{moment(startdatetime).format('DD MMM YYYY')} - {moment(enddatetime).format('DD MMM YYYY')}</span>
    }

    const showModalHoliday = (holidayData) => {
      props.handleEditHoliday(holidayData)
    }

    const showDeleteModal = (holidayData) => {
      setDeleteModal(true)
      setSelectedHolidayRequest(holidayData)
    }

    const deleteHolidayRequest = async () => {
      await db.DeleteAbsenceRequest(selectedholidayrequest.request_id, client.UserName)
      setSelectedHolidayRequest(null)
      props.updateStudents()
      deleteRef?.current?.handleClose()
      setDeleteModal(false)
    }

    const closeDeleteModal = () => {
      deleteRef?.current?.handleClose()
      setSelectedHolidayRequest(null)
      setDeleteModal(false)
    }

  const [deleteModal, setDeleteModal] = useState(false)
  const deleteRef = useRef(null);

  return (
    <>
      {deleteModal?<Modal ref={deleteRef} onClose={closeDeleteModal} backColor='rgba(0,0,0,0.25)' clickOutside={true}>
          <PopContainer>
            <PopTitle>{i18n.t("guardian-holiday-text")}</PopTitle>
            <HeadLine />
            <PopRow>{i18n.t("guardian-holiday-edit-popup-delete-text")}</PopRow>
            <PopRow>
              <Buttons>
                <button onClick={() => deleteHolidayRequest()}>{i18n.t("delete-reward")}</button>
                <button onClick={() => closeDeleteModal()}>{i18n.t("cancel")}</button>
              </Buttons>
            </PopRow>
          </PopContainer>
      </Modal>:null}

      <Container>
        <TopTitle>
          <span>{i18n.t("guardian-holiday-text")}</span>
        </TopTitle>
        <CardInfo padding={true} text={"info-text-holiday"} />
        <BT onClick={() => setShowAll(prev => !prev)}>{showAll?i18n.t("show-newest"):i18n.t("show-all")}</BT>
        {!props.loading?
          <ListContainer>
            {filterActivities()?.length > 0?filterActivities()?.map((hr, index) => {
              let student = getStudent(hr.student_id)
              return <ListItem key={"guardian_holiday_item_" + index}>
                <ImageContainer>
                  <StudentThumbnail name={student?.student_displayname} src={student?.student_username} />
                </ImageContainer>
                <ItemInfo>
                  <ItemName>{student?.student_displayname}</ItemName>
                  {/* <TagPill PColor={"rgb(41, 128, 185)"}>{i18n.t("guardian-holiday-text")}</TagPill> */}
                  <div><Calendar_Icon /> {getTime(hr.startdatetime, hr.enddatetime)}</div>
                  <div>{getStatus(hr.approved, hr.waiting)}</div>
                  {hr.request_text !== null && hr.request_text !== ""?<>
                    <span><b>{toTitleCase(i18n.t("note"))}:</b> {hr.request_text}</span>
                  </>:null}
                  {hr.approve_text !== null && hr.approve_text !== ""?<>
                    <br />
                    <span><b>{i18n.t("note-approval")}:</b> {hr.approve_text}</span>
                  </>:null}
                </ItemInfo>
                {moment(hr.startdatetime).isAfter(moment(), 'day') && hr.waiting?
                <ItemButtons>
                  <button onClick={() => showDeleteModal(hr)}>{i18n.t("delete-reward")}</button>
                  <button onClick={() => props.handleEditHoliday(hr)}>{i18n.t("edit")}</button>
                </ItemButtons>:null}
              </ListItem>
            }
            )
          :
            <EmptyBox Graphic='user' text={i18n.t("guardian-holiday-header-text1")} />
          }
          </ListContainer>
        :
          <RainbowLoader />
        }

      </Container>
    </>
  );
};

export default GuardianHoliday;
